(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nrh-approach"]) return;
  try {
    
(() => {
  function initialize(scope){
    const container=scope.querySelector('[data-nrh-consult]');
    if(!container||container.dataset.ready)return;
    container.dataset.ready='true';
    const form=container.querySelector('#nrh-consult-form');
    if(!form)return;
    const steps=Array.from(form.querySelectorAll('[data-consult-step]'));
    const success=form.querySelector('.nrh-consult-success');
    if(success){success.focus();return;}
    if(!steps.length)return;
    const copy=JSON.parse(document.querySelector('[data-consult-copy]').textContent);
    let step=0;
    const input=id=>form.querySelector('#consult-'+id);
    const progress=form.querySelector('[data-consult-progress]'),controls=form.querySelector('[data-consult-controls]'),next=form.querySelector('[data-consult-next]'),back=form.querySelector('[data-consult-back]'),review=form.querySelector('[data-consult-review]'),edit=form.querySelector('[data-consult-edit]');
    function phoneRequirement(){const required=input('method').value==='Phone call';input('phone').required=required;form.querySelector('[data-phone-optional]').hidden=required;}
    function updateReview(){
      form.querySelector('[data-review-name]').textContent=input('first').value.trim()+' '+input('last').value.trim();
      form.querySelector('[data-review-contact]').textContent=input('email').value+(input('phone').value?' · '+input('phone').value:'')+' · '+input('method').selectedOptions[0].textContent;
      form.querySelector('[data-review-location]').textContent=input('zip').value+' · '+input('country').value;
      form.querySelector('[data-review-format]').textContent=input('format').value;
    }
    function go(index,focus=true){step=index;steps.forEach((part,i)=>part.hidden=i!==step);back.hidden=step===0;next.hidden=step===2;form.querySelector('[data-consult-step-text]').textContent=copy.step.replace('__step__',String(step+1));form.querySelector('[data-consult-bar]').style.width=((step+1)/3*100)+'%';if(step===2)updateReview();if(focus)steps[step].querySelector('legend').focus();}
    function validate(index){const fields=Array.from(steps[index].querySelectorAll('input,select'));const invalid=fields.find(field=>!field.checkValidity());if(invalid){go(index,false);invalid.reportValidity();return false;}return true;}
    next.addEventListener('click',()=>{phoneRequirement();if(validate(step))go(Math.min(2,step+1));});
    back.addEventListener('click',()=>go(Math.max(0,step-1)));
    edit.addEventListener('click',()=>go(1));
    input('method').addEventListener('change',phoneRequirement);
    form.addEventListener('submit',event=>{
      phoneRequirement();
      if(step<2){event.preventDefault();if(validate(step))go(step+1);return;}
      for(let index=0;index<steps.length;index++){if(!validate(index)){event.preventDefault();return;}}
      form.querySelector('[data-consult-time]').value=new Date().toISOString();
    });
    form.noValidate=true;progress.hidden=false;controls.hidden=false;review.hidden=false;edit.hidden=false;phoneRequirement();go(0,false);
    if(form.querySelector('.nrh-consult-errors')){steps.forEach(part=>part.hidden=false);controls.hidden=true;progress.hidden=true;step=2;form.querySelector('.nrh-consult-errors').focus();}
  }
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
